<ng-template #preTradingModal let-modal>
   <div class="modal-body p-0 text-center bg-transparent border-0 text-white">
      <article class="position-relative">
         <button type="button" class="border-0 p-2 bg-transparent text-white position-absolute top-0 end-0" aria-label="Close" (click)="closePreTradingModal()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
               <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 6L6 18m12 0L6 6"/>
            </svg>
         </button>

         <h4 class="mb-3 mb-lg-2 fw-normal">
            Pre-Trading Campaign
         </h4>
         <h5 class="mb-0 fw-600 lh-sm">
            Invest in <strong class="text-green fw-600">Musaffa</strong>
         </h5>
         <p class="mb-0 fw-normal trading-para">
            Get Halal Trading <strong class="text-green text-uppercase fw-600 free-span">Free</strong>  
            <span class="d-block">Worth <strong class="text-green fw-600">$360</strong> per year</span>
            for up to <strong class="text-green fw-600">6 years!</strong>
         </p>

         <div class="countdown-section mx-auto">
            <div class="countdown-timer">
               <div class="time-unit d-flex flex-column align-items-center gap-1 gap-lg-2">
                  <span class="time-number fw-600 lh-1">{{ countdown.days | number : "2.0" }}</span>
                  <span class="time-label text-white text-uppercase">DAY</span>
               </div>
               <div class="time-unit d-flex flex-column align-items-center gap-1 gap-lg-2">
                  <span class="time-number fw-600 lh-1">{{ countdown.hours | number : "2.0" }}</span>
                  <span class="time-label text-white text-uppercase">HOUR</span>
               </div>
               <div class="time-unit d-flex flex-column align-items-center gap-1 gap-lg-2">
                  <span class="time-number fw-600 lh-1">{{ countdown.minutes | number : "2.0" }}</span>
                  <span class="time-label text-white text-uppercase">MIN</span>
               </div>
               <div class="time-unit d-flex flex-column align-items-center gap-1 gap-lg-2">
                  <span class="time-number fw-600 lh-1">{{ countdown.seconds | number : "2.0" }}</span>
                  <span class="time-label text-white text-uppercase">SEC</span>
               </div>
            </div>
         </div>

         <div class="progress-wrapper text-start mx-auto p-3 p-lg-4 my-3 my-lg-4">
            <h6 class="text-uppercase fw-500 mb-0 lh-base">
               Hurry, Offer is Limited <br class="d-lg-none"> to the <strong class="text-green fw-600">First 100 People</strong> Only!
            </h6>

            <div class="progress bg-white rounded-pill my-2 my-lg-3">
               <div 
                  class="progress-bar rounded-pill"
                  role="progressbar"
                  [style.width]="(preTradingData.currentPeople / preTradingData.maxPeople * 100) + '%'"
                  [attr.aria-valuenow]="preTradingData.currentPeople"
                  [attr.aria-valuemin]="0"
                  [attr.aria-valuemax]="preTradingData.maxPeople"
               >
               </div>
            </div>

            <p class="mb-0 leftout-para lh-1">{{ preTradingData.maxPeople - preTradingData.currentPeople }} left out of {{ preTradingData.maxPeople }}</p>
         </div>

         <a href="https://invest.musaffa.com/?utm_source=mainwebsite&utm_medium=referral&utm_campaign=cf-2025" (click)="closePreTradingModal()" target="_blank" rel="noopener noreferrer"
            class="border-0 mx-auto text-white text-decoration-none text-center fw-600 d-block w-100 invest-halal-btn">
            Invest Now
         </a>
      </article>
         
   </div>
   
 </ng-template>
